// extracted by css-extract-rspack-plugin
export default {"messengerDeepLink":"messenger-deep-link--VUg7Of8yV_sPVaNM"};